<template>
    <!-- Dashboard Right Content -->
    <div class="rbt-right-side-panel popup-dashboardright-section" >
        <div class="right-side-bottom" >
            <div class="small-search search-section mb--20">
                <input type="search" placeholder="Pesquise seus pareceres..." v-model="dsFiltro" v-on:keyup.enter="load" @focusout="load">
                <i class="feather-search"></i>
            </div>
            <div class="chat-history-section" v-if="lstHoje.length > 0">
                <h6 class="title">Histórico</h6>
                <ul class="chat-history-list position-relative mt-5">
                    <li v-for="(item,index) in lstHoje" :key="index" :class="'history-box mb-3 '+(idConversa == item.idConversa? 'active':'')" data-bs-toggle="popover" data-bs-placement="left" title="Detalhes"
                        :data-bs-content="getDataBs(item)">
                        <a class="reduz-texto-2" type="_blanl" href="javascript:void(0)" @click="selecionaConversa(item.idConversa)">
                            {{item.dsPergunta}}
                        </a>
                        <div class="dropdown history-box-dropdown">
                            <button type="button" class="more-info-icon dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                <i class="feather-more-horizontal"></i>
                            </button>
                            <ul class="dropdown-menu">
                                <li>
                                    <a :class="'dropdown-item ' + (user.usuario.dsLogin != item.dsLogin?'disabled':'')" href="javascript:void(0)" @click="excluir(item.idConversa)" :disabled="(user.usuario.dsLogin != item.dsLogin)">
                                        <i class="feather-trash"></i>
                                        Excluir
                                    </a>
                                </li>
                                <!--<li>
                                    <a class="dropdown-item" href="#">
                                        <i class="feather-refresh-cw"></i>
                                        Regenerar
                                    </a>
                                </li>
                                <li><a class="dropdown-item" href="#"><i class="feather-tag"></i>Imprimir</a></li>
                                <li>
                                    <a class="dropdown-item" href="#">
                                        <i class="feather-file-text"></i>
                                        Renomear
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="#">
                                        <i class="feather-share-2"></i>
                                        Compartilhar
                                    </a>
                                </li>-->
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="chat-history-section has-show-more" v-if="lstOntem.length > 0">
                <h6 class="title">Ontem</h6>
                <ul class="chat-history-list position-relative">
                    <li v-for="(item,index) in lstOntem" :key="index" class="bg-flashlight rounded" data-bs-toggle="popover" data-bs-placement="left" title="Detalhes"
                        :data-bs-content="getDataBs(item)">
                        <div class="history-box inner top-flashlight leftside light-xl" @click="selecionaConversa(item.idConversa)">
                            <a class="reduz-texto-2" type="_blanl" href="javascript:void(0)">
                                {{item.dsPergunta}}
                            </a>
                            <div class="dropdown history-box-dropdown">
                                <button type="button" class="more-info-icon dropdown-toggle" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                    <i class="feather-more-horizontal"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-refresh-cw"></i>
                                            Regenerar
                                        </a>
                                    </li>
                                    <li><a class="dropdown-item" href="#"><i class="feather-tag"></i>Imprimir</a></li>
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-file-text"></i>
                                            Renomear
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-share-2"></i>
                                            Compartilhar
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="rbt-show-more-btn">Mostrar Mais</div>
            </div>

            <div class="chat-history-section has-show-more box-padding-b" v-if="lstOutros.length > 0">
                <h6 class="title">Últimos 30 dias</h6>
                <ul class="chat-history-list position-relative">
                    <li v-for="(item,index) in lstOutros" :key="index" class="bg-flashlight rounded" data-bs-toggle="popover" data-bs-placement="left" title="Detalhes"
                        :data-bs-content="getDataBs(item)">
                        <div class="history-box inner top-flashlight leftside light-xl" @click="selecionaConversa(item.idConversa)">
                            <a class="reduz-texto-2" type="_blanl" href="javascript:void(0)">
                                {{item.dsPergunta}}
                            </a>
                            <div class="dropdown history-box-dropdown">
                                <button type="button" class="more-info-icon dropdown-toggle" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                    <i class="feather-more-horizontal"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-refresh-cw"></i>
                                            Regenerar
                                        </a>
                                    </li>
                                    <li><a class="dropdown-item" href="#"><i class="feather-tag"></i>Imprimir</a></li>
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-file-text"></i>
                                            Renomear
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">
                                            <i class="feather-share-2"></i>
                                            Compartilhar
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="rbt-show-more-btn">Mostrar Mais</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'HistoricoPerguntas',
        components: {},
        computed: {
            user() {
                return this.$store.state.user
            },

        },
        props: {
            selecionaConversa: {
                type: Function,
                required: true,
            },
            reload: {
                type: Boolean,
                default: false
            },
            idConversa: {
                type: Number,
                default: 0
            },
        },
        data: function () {
            return {
                dsFiltro: null,

                lstHoje: [],

                lstOntem: [],

                lstOutros: [],
            }
        },
        methods: {
            getDataBs(item) {
                let tpPergunta = (item.tpPergunta == "RO" || item.tpPergunta == "Resposta Objetiva" ? "Resposta Objetiva" : "Parecer Técnico");
                //let status = (item.status == "Finalizada" ? 'text-success' : 'text-danger');

                return ` <span class="mb-0"><strong>Tipo:</strong> ${tpPergunta}</span> 
                 <span class="mb-0"><strong>Data:</strong> ${item.dtPergunta}</span> 
                <p class="mb-0"><strong>Pergunta:</strong> ${item.dsPergunta}</p> `;
            },

            getHoje() {
                let $this = this;
                //let dtInicio = moment().format('YYYY-MM-DD') + ' 00:00:00';
                //let dtFim = moment().format('YYYY-MM-DD') + ' 23:59:59';
                axios.get(`${urlApi}/Conversa/GetHistorico`, { showLoading: false, params: { dsTermo: this.dsFiltro /*dtInicio: dtInicio, dtFim: dtFim */} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstHoje = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtPergunta = moment(item.dtInclusao).format('DD/MM/YYYY [às] HH:mm');
                                                                
                                $this.lstHoje.push(item);
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },

            getOntem() {
                let $this = this;
                let dtInicio = moment().add(-1, 'd').format('YYYY-MM-DD') + ' 00:00:00';
                let dtFim = moment().add(-1, 'd').format('YYYY-MM-DD') + ' 23:59:59';
                axios.get(`${urlApi}/Conversa/Get`, { showLoading: false, params: { dtInicio: dtInicio, dtFim: dtFim } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstOntem = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                var status, dtAtualizacao = '';
                                if (item.lstConversaMovimento.length > 0) {
                                    status = item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dsMovimento;
                                    dtAtualizacao = moment(item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dtInclusao).format('DD/MM/YYYY [às] HH:mm');
                                }

                                var pergunta = {
                                    idConversa: item.conversa.idConversa,
                                    dsPergunta: item.conversa.dsPergunta,
                                    dsResposta: item.conversa.dsResposta,
                                    tpPergunta: item.conversa.tpPergunta,
                                    dsLogin: item.conversa.dsLogin,
                                    dtPergunta: moment(item.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    status: status,
                                    dtAtualizacao: dtAtualizacao,
                                };
                                $this.lstOntem.push(pergunta);
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },

            getOutros() {
                let $this = this;
                let dtFim = moment().add(-2, 'd').format('YYYY-MM-DD') + ' 23:59:59';
                axios.get(`${urlApi}/Conversa/Get`, { showLoading: false, params: { index: 0, take: 10, dtFim: dtFim } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstOutros = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                var status, dtAtualizacao = '';
                                if (item.lstConversaMovimento.length > 0) {
                                    status = item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dsMovimento;
                                    dtAtualizacao = moment(item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dtInclusao).format('DD/MM/YYYY [às] HH:mm');
                                }

                                var pergunta = {
                                    idConversa: item.conversa.idConversa,
                                    dsPergunta: item.conversa.dsPergunta,
                                    dsResposta: item.conversa.dsResposta,
                                    tpPergunta: item.conversa.tpPergunta,
                                    dsLogin: item.conversa.dsLogin,
                                    dtPergunta: moment(item.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    status: status,
                                    dtAtualizacao: dtAtualizacao,
                                };
                                $this.lstOutros.push(pergunta);
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },

            montaPopover() {
                window.$(".popover").each(function () {
                    window.$(this).remove();
                });
                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "left",
                                });
                            });
                    }
                });
            },

            excluir(idConversa) {
                let $this = this;
                axios.delete(`${urlApi}/Conversa/Delete`, { params: { id: idConversa } })
                    .then(res => {
                        if (res.data.success) {
                            $this.load();
                            avisoToast("Pergunta removida com sucesso");
                        } else {
                            avisoErro("Não foi remover a pergunta.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi remover a pergunta.");
                        }
                    });
            },

            load() {
                this.getHoje();
                //this.getOntem();
                //this.getOutros();
            }
        },
        mounted: function () {
            this.load();
        },
        watch: {
            dsFiltro: function () {
                if (this.dsFiltro.length > 3) {
                    this.load();
                } else {
                    if (this.dsFiltro == "") {
                        this.load();
                    }
                }
            },
            reload: function () {
                this.load();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .chat-history-list a {
        color: black;
    }
    .chat-history-list a:hover {
        color: #FFF;
    }
    .chat-history-list .active a {
        color: #FFF;
    }

    .small-search.search-section input, .small-search.search-section input {
        border-color: var(--color-primary) !important;
        outline: none;
    }

    .top-flashlight.light-xl::before {
        width: 70%;
    }

    .history-box {
        background: rgb(135, 173, 216);
        background: linear-gradient(141deg, rgba(135, 173, 216, 1) 0%, rgba(213, 235, 234, 1) 1%, rgba(255, 255, 255, 1) 100%);
        color: #FFF;
    }
    .dropdown-item.disabled{
        text-decoration: line-through;
    }

</style>


